import { render, staticRenderFns } from "./RegistrationTerminals.vue?vue&type=template&id=94a19a48"
import script from "./RegistrationTerminals.vue?vue&type=script&lang=js"
export * from "./RegistrationTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports